import curry from 'lodash/curry';
import classNames from 'classnames';
export var globalKey = 'rs-';
export var getClassNamePrefix = function getClassNamePrefix() {
  return globalKey;
};
export var defaultClassPrefix = function defaultClassPrefix(name) {
  return name ? "" + getClassNamePrefix() + name : undefined;
};
export var prefix = curry(function (pre, className) {
  if (!pre || !className) {
    return '';
  }

  if (Array.isArray(className)) {
    return classNames(className.filter(function (name) {
      return !!name;
    }).map(function (name) {
      return pre + "-" + name;
    }));
  }

  return pre + "-" + className;
});